import { snapshot } from "valtio";
import { ProductData } from "@/types/product";
import store from "@/store";

const updateProductInLocal = async (product: ProductData, newProduct: ProductData[] = []) => {
    const { products } = snapshot(store);
    const otherProducts = products.filter(p => p.product_id !== product.product_id);

    const updatedProduct = JSON.parse(JSON.stringify(product));

    store.products = [...newProduct, updatedProduct, ...otherProducts];
};

export default updateProductInLocal;
